import { __extends, __awaiter, __makeTemplateObject, __decorate, __metadata, __assign as _assign, __generator } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x, nothing as A } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../node_modules/@babel/runtime/regenerator/index.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../node_modules/lit-html/directives/if-defined.js';
import { createPopper } from '../../node_modules/@popperjs/core/dist/esm/popper.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { PvdSlotifyBaseComponent } from '../pvd-base-component/pvd-slotify-base-component.js';
import { LayerPosition } from '../pvd-utils/enums/layer-position.js';
import { KeyboardKey, LegacyKeyboardKey } from '../pvd-utils/enums/keyboard-key.js';
import { getElement } from '../pvd-utils/scripts/get-element.js';
import { getCloseIfTriggerHiddenPopperModifier } from '../pvd-utils/scripts/get-close-if-trigger-hidden-popper-modifier.js';
import { getCurrentPlacementPopperModifier } from '../pvd-utils/scripts/get-current-placement-popper-modifier.js';
import { getZIndexPopperModifier } from '../pvd-utils/scripts/get-z-index-popper-modifier.js';

var DEFAULT_BOUNDARY = 'clippingParents';
var DEFAULT_OPEN = false;
var DEFAULT_DISABLE_OVERFLOW = false;
var DEFAULT_PLACEMENT = LayerPosition.top;
var DEFAULT_DISABLE_TRIGGER_SLOT_BUTTON = false;
/**
 * Providence Tooltip component.
 * @see {@link https://providence.fmr.com/components/tooltip/tooltip.html|Tooltip documentation}
 */
var PvdTooltip = /** @class */ (function (_super) {
    __extends(PvdTooltip, _super);
    function PvdTooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // public event handlers
        // function to call when user clicks outside Tooltip
        _this.onClickOutside = function (e) { return (_this.pvdOpen = false); };
        /**
         * Prevents the overflow mutation observer from being created or destroyed
         */
        _this.pvdDisableOverflow = DEFAULT_DISABLE_OVERFLOW;
        /**
         * Disables the "button" wrapper functionality from trigger slot
         */
        _this.pvdDisableTriggerSlotButton = DEFAULT_DISABLE_TRIGGER_SLOT_BUTTON;
        /**
         * Shows/Hides the tooltip element
         */
        _this.pvdOpen = DEFAULT_OPEN;
        /**
         * Placement of the tooltip
         */
        _this.pvdPlacement = DEFAULT_PLACEMENT;
        return _this;
        // #endregion
    }
    Object.defineProperty(PvdTooltip.prototype, "hasTrigger", {
        // #endregion
        //#region public methods
        // #endregion
        //#region protected methods
        /**
         * Determines if the consumer provided a slotted trigger
         */
        get: function () {
            return this.hasSlotableContent('trigger');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdTooltip.prototype, "boundary", {
        // #endregion
        //#region private methods
        /**
         * Returns the element reference that was either provided through the pvdBoundary prop, or the result of a querySelector whos value was this.pvdBoundary
         */
        get: function () {
            return getElement(this.pvdBoundary) || DEFAULT_BOUNDARY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdTooltip.prototype, "target", {
        /**
         * Returns the element reference that was either provided through the pvdTarget prop, or the result of a querySelector whos value was this.pvdTarget
         */
        get: function () {
            return getElement(this.pvdTarget);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdTooltip.prototype, "popperJsModifiers", {
        /**
         * Returns an array of the modifiers used to configure PopperJS instance
         */
        get: function () {
            var currentPlacementModifier = getCurrentPlacementPopperModifier.call(this);
            var zIndexModifier = getZIndexPopperModifier.call(this);
            var closeIfTriggerHiddenModifier = getCloseIfTriggerHiddenPopperModifier.call(this, PvdTooltip.componentName);
            return [
                currentPlacementModifier,
                zIndexModifier,
                closeIfTriggerHiddenModifier,
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: ['top', 'right', 'bottom', 'left'],
                        boundary: this.boundary,
                    },
                },
                {
                    name: 'offset',
                    options: {
                        offset: [0, 20],
                    },
                },
                {
                    name: 'arrow',
                    options: {
                        element: this._arrowElement,
                        padding: 24,
                    },
                },
                {
                    name: 'preventOverflow',
                    options: {
                        altAxis: true,
                        boundary: this.boundary,
                    },
                },
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdTooltip.prototype, "generatedTooltipId", {
        /**
         * Generates a unique ID if one is not provided within the component
         */
        get: function () {
            if (!this._generatedTooltipId) {
                // Id must start with a letter
                this._generatedTooltipId = "pvd-tooltip-id-".concat(PvdSlotifyBaseComponent.generateRandomNumber());
            }
            return this._generatedTooltipId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdTooltip.prototype, "tooltipId", {
        /**
         * Returns the given tooltip ID or the internally generated ID
         */
        get: function () {
            return this.pvdId || this.generatedTooltipId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdTooltip.prototype, "ariaLabelledby", {
        /**
         * Returns the necessary `aria-labelledby` value
         */
        get: function () {
            // return `undefined` if we plan to announce the trigger
            if (this.pvdA11yAnnounceTrigger) {
                return;
            }
            // default to tooltipId
            return this.tooltipId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdTooltip.prototype, "ariaDescribedby", {
        /**
         * Returns the necessary `aria-describedby` value
         */
        get: function () {
            // don't add aria-describedby if they don't want to announce trigger
            if (!this.pvdA11yAnnounceTrigger) {
                return;
            }
            // default to tooltipId
            return this.tooltipId;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Callback when 'pvdOpen' changes
     */
    PvdTooltip.prototype.openStateChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var addOrRemoveListener;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        addOrRemoveListener = this.pvdOpen
                            ? this.addClickOutsideListener.bind(this)
                            : this.removeClickOutsideListener.bind(this);
                        // manage add/remove click outsidelistener
                        return [4 /*yield*/, addOrRemoveListener()];
                    case 1:
                        // manage add/remove click outsidelistener
                        _a.sent();
                        // Asynchronously updates the popper instance, and returns a promise. Use this for high-frequency updates.
                        return [4 /*yield*/, this.updateComplete];
                    case 2:
                        // Asynchronously updates the popper instance, and returns a promise. Use this for high-frequency updates.
                        _a.sent();
                        // fire the open event
                        this.dispatchEvent(new CustomEvent('pvd-tooltip-change', { detail: { open: this.pvdOpen } }));
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sets the boundary element for the PopperJS modifiers
     * @see https://popper.js.org/docs/v2/utils/detect-overflow/#boundary
     */
    PvdTooltip.prototype.boundaryStateChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._popper) {
                            return [2 /*return*/];
                        }
                        this._popper.setOptions({ modifiers: this.popperJsModifiers });
                        return [4 /*yield*/, this._popper.update()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Callback method when 'pvdPlacement' is changed
     */
    PvdTooltip.prototype.placementStateChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._popper) {
                            return [2 /*return*/];
                        }
                        this._popper.setOptions({ placement: this.pvdPlacement });
                        return [4 /*yield*/, this._popper.update()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Callback method when 'pvdTarget' is changed
     */
    PvdTooltip.prototype.targetStateChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setup();
                return [2 /*return*/];
            });
        });
    };
    /**
     * Sets the zIndex modifier for PopperJS instance
     */
    PvdTooltip.prototype.zIndexStateChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._popper) {
                            return [2 /*return*/];
                        }
                        this._popper.setOptions({ modifiers: this.popperJsModifiers });
                        return [4 /*yield*/, this._popper.update()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PvdTooltip.prototype.setup = function () {
        // if a popper instance exists, we need to tear down before setting back up
        if (this._popper) {
            this.removePopperInstance();
            this.removeTriggerEventHandlers();
        }
        // set up new element references, new popper instance, and new mutation observer
        // cache element references
        this.addElementReferences();
        // add the trigger event listeners
        this.addTriggerEventHandlers();
        // create the popperJS instance
        this.addPopperInstance();
    };
    /**
     * Caches internal element references for use throughout the component lifecycle
     */
    PvdTooltip.prototype.addElementReferences = function () {
        this._triggerElement = this.hasTrigger
            ? this.querySelector(".pvd-tooltip__trigger-wrapper")
            : this.target;
        this._tooltipElement = this.querySelector(".pvd-tooltip__wrapper");
        this._arrowElement = this._tooltipElement.querySelector(".pvd-tooltip__arrow");
    };
    /**
     * Adds event handlers for the tooltip trigger
     */
    PvdTooltip.prototype.addTriggerEventHandlers = function () {
        if (this._triggerElement) {
            // mouseenter event
            this._boundMouseoverHandler = this.triggerMouseoverHandler.bind(this);
            this._triggerElement.addEventListener('mouseenter', this._boundMouseoverHandler);
            // mouseleave event
            this._boundMouseleaveHandler = this.triggerMouseleaveHandler.bind(this);
            this._triggerElement.addEventListener('mouseleave', this._boundMouseleaveHandler);
            // focus event
            this._boundFocusHandler = this.triggerFocusHandler.bind(this);
            this._triggerElement.addEventListener('focus', this._boundFocusHandler, true);
            // keydown event
            this._boundKeyboardHandler = this.keyboardEventHandler.bind(this);
            this._triggerElement.addEventListener('keydown', this._boundKeyboardHandler);
        }
    };
    /**
     * Removes event handlers for the tooltip trigger
     */
    PvdTooltip.prototype.removeTriggerEventHandlers = function () {
        if (this._triggerElement) {
            // keydown event
            this._triggerElement.removeEventListener('keydown', this._boundKeyboardHandler);
            this._boundKeyboardHandler = undefined;
            // focus event
            this._triggerElement.removeEventListener('focus', this._boundFocusHandler, true);
            this._boundFocusHandler = undefined;
            // mouseenter event
            this._triggerElement.removeEventListener('mouseenter', this._boundMouseoverHandler);
            this._boundMouseoverHandler = undefined;
            // mouseleave event
            this._triggerElement.removeEventListener('mouseleave', this._boundMouseleaveHandler);
            this._boundMouseleaveHandler = undefined;
        }
    };
    /**
     * Initializes the popperjs instance and merges user provided options
     */
    PvdTooltip.prototype.addPopperInstance = function () {
        // no trigger, no popper
        if (!this._triggerElement) {
            return;
        }
        if (!this._popper) {
            // popper.js
            this._popper = createPopper(this._triggerElement, this._tooltipElement, {
                placement: this.pvdPlacement,
                modifiers: this.popperJsModifiers,
            });
        }
    };
    /**
     * Tears down the popperjs instance and sets the internal reference to `undefined`
     */
    PvdTooltip.prototype.removePopperInstance = function () {
        if (this._popper) {
            this._popper.destroy();
            this._popper = undefined;
        }
    };
    /**
     * Adds the click handler outside the tooltip
     */
    PvdTooltip.prototype.addClickOutsideListener = function () {
        this._boundClickOutsideHandler = this.clickOutsideEventHandler.bind(this);
        document.body.addEventListener('click', this._boundClickOutsideHandler);
    };
    /**
     * Removes the click handler outside the tooltip
     */
    PvdTooltip.prototype.removeClickOutsideListener = function () {
        if (this._boundClickOutsideHandler) {
            document.body.removeEventListener('click', this._boundClickOutsideHandler);
            this._boundClickOutsideHandler = undefined;
        }
    };
    // #endregion
    //#region events
    /**
     * Handles keyboard input while trigger element has focus
     * @param e KeyboardEvent
     */
    PvdTooltip.prototype.keyboardEventHandler = function (e) {
        var isTabPressed = e.key === KeyboardKey.tab || e.key === LegacyKeyboardKey.tab;
        var isEscapePressed = e.key === KeyboardKey.escape || e.key === LegacyKeyboardKey.escape;
        // TAB or SHIFT+TAB
        if (isTabPressed || isEscapePressed) {
            this.pvdOpen = false;
        }
    };
    /**
     * Hanldles trigger element focus event
     * @param e Event
     */
    PvdTooltip.prototype.triggerFocusHandler = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateComplete];
                    case 1:
                        _a.sent();
                        this.pvdOpen = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Handles trigger mouseover event
     * @param e Event
     */
    PvdTooltip.prototype.triggerMouseoverHandler = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateComplete];
                    case 1:
                        _a.sent();
                        this.pvdOpen = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Handles trigger mouseleave event
     * @param e Event
     */
    PvdTooltip.prototype.triggerMouseleaveHandler = function (e) {
        this.pvdOpen = false;
    };
    /**
     * Handles clicks outside the tooltip or tooltip trigger
     * @param e Mouse event object
     */
    PvdTooltip.prototype.clickOutsideEventHandler = function (e) {
        if (!this._tooltipElement.contains(e.target) &&
            !this._triggerElement.contains(e.target)) {
            // prevent calling the function if the `onClickOutside` has been set to `undefined`
            if (typeof this.onClickOutside !== 'undefined') {
                this.onClickOutside(e);
            }
        }
    };
    // #endregion
    // #region LitElement lifecycles
    PvdTooltip.prototype.updated = function (changes) {
        _super.prototype.updated.call(this, changes);
        if (changes.has('pvdOpen')) {
            this.openStateChange();
        }
        if (changes.has('pvdBoundary')) {
            this.boundaryStateChange();
        }
        if (changes.has('pvdPlacement')) {
            this.placementStateChange();
        }
        if (changes.has('pvdTarget')) {
            this.targetStateChange();
        }
        if (changes.has('pvdZIndex')) {
            this.zIndexStateChange();
        }
    };
    PvdTooltip.prototype.firstUpdated = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _super.prototype.firstUpdated.call(this);
                        // `this.updateComplete` needed so that we can reference DOM nodes in popperjs setup
                        return [4 /*yield*/, this.updateComplete];
                    case 1:
                        // `this.updateComplete` needed so that we can reference DOM nodes in popperjs setup
                        _a.sent();
                        this.setup();
                        return [2 /*return*/];
                }
            });
        });
    };
    PvdTooltip.prototype.disconnectedCallback = function () {
        _super.prototype.disconnectedCallback.call(this);
        this.removePopperInstance();
        this.removeTriggerEventHandlers();
        this.removeClickOutsideListener();
    };
    /**
     * Overrides `_getUpdateComplete` so that async calls to this.updateComplete include the returned promises from this method
     */
    PvdTooltip.prototype._getUpdateComplete = function () {
        return __awaiter(this, void 0, void 0, function () {
            var popperUpdate;
            return __generator(this, function (_a) {
                popperUpdate = this._popper ? this._popper.update() : undefined;
                return [2 /*return*/, Promise.all([_super.prototype._getUpdateComplete.call(this), popperUpdate])];
            });
        });
    };
    /**
     * Renders the template for the trigger
     */
    PvdTooltip.prototype.renderTrigger = function () {
        return x(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), this.hasTrigger
            ? x(templateObject_1 || (templateObject_1 = __makeTemplateObject(["<div\n          aria-describedby=\"", "\"\n          aria-label=\"", "\"\n          aria-labelledby=\"", "\"\n          class=\"pvd-tooltip__trigger-wrapper\"\n          role=\"", "\"\n          tabindex=\"", "\"\n        >\n          <span aria-hidden=\"", "\"\n            ><s-slot name=\"trigger\"></s-slot\n          ></span>\n        </div>"], ["<div\n          aria-describedby=\"", "\"\n          aria-label=\"", "\"\n          aria-labelledby=\"", "\"\n          class=\"pvd-tooltip__trigger-wrapper\"\n          role=\"", "\"\n          tabindex=\"", "\"\n        >\n          <span aria-hidden=\"", "\"\n            ><s-slot name=\"trigger\"></s-slot\n          ></span>\n        </div>"])), l(this.ariaDescribedby), l(this.pvdTriggerButtonA11yText), l(this.ariaLabelledby), l(this.pvdDisableTriggerSlotButton ? undefined : "button"), l(this.pvdDisableTriggerSlotButton ? undefined : "0"), l(this.pvdA11yAnnounceTrigger ? undefined : true)) : A);
    };
    /**
     * main render method of Tooltip
     */
    PvdTooltip.prototype.render = function () {
        var classMap = {
            default: "".concat(this.constructor.namespace, "-tooltip-root"),
            modifierPrefix: 'pvd-tooltip',
            modifiers: [
                {
                    condition: this.pvdOpen,
                    className: 'open',
                },
                {
                    condition: LayerPosition[this.pvdCurrentPlacement] !== undefined,
                    className: "placement-".concat(this.pvdCurrentPlacement),
                },
            ],
        };
        return x(templateObject_3 || (templateObject_3 = __makeTemplateObject(["<div class=\"", "\">\n      ", "\n      <div class=\"pvd-tooltip__wrapper\">\n        <div class=\"pvd-tooltip__tooltip\" id=\"", "\" role=\"tooltip\">\n          <span class=\"pvd-tooltip__text\"><s-slot>", "</s-slot></span>\n        </div>\n        <span class=\"pvd-tooltip__arrow\"></span>\n      </div>\n    </div>"], ["<div class=\"", "\">\n      ", "\n      <div class=\"pvd-tooltip__wrapper\">\n        <div class=\"pvd-tooltip__tooltip\" id=\"", "\" role=\"tooltip\">\n          <span class=\"pvd-tooltip__text\"><s-slot>", "</s-slot></span>\n        </div>\n        <span class=\"pvd-tooltip__arrow\"></span>\n      </div>\n    </div>"])), getClassName(classMap), this.renderTrigger(), this.tooltipId, this.pvdText);
    };
    //#region Component configuration
    PvdTooltip.componentName = 'tooltip';
    __decorate([
        t(),
        __metadata("design:type", String)
    ], PvdTooltip.prototype, "pvdCurrentPlacement", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-a11y-announce-trigger' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-a11y-announce-trigger'))),
        __metadata("design:type", Boolean)
    ], PvdTooltip.prototype, "pvdA11yAnnounceTrigger", void 0);
    __decorate([
        n({
            type: String,
            reflect: true,
            attribute: 'pvd-boundary',
        }),
        __metadata("design:type", Object)
    ], PvdTooltip.prototype, "pvdBoundary", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: false, attribute: 'pvd-disable-overflow' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-disable-overflow'))),
        __metadata("design:type", Boolean)
    ], PvdTooltip.prototype, "pvdDisableOverflow", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-disable-trigger-slot-button' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-disable-trigger-slot-button'))),
        __metadata("design:type", Boolean)
    ], PvdTooltip.prototype, "pvdDisableTriggerSlotButton", void 0);
    __decorate([
        n({
            type: String,
            reflect: true,
            attribute: 'pvd-id',
        }),
        __metadata("design:type", String)
    ], PvdTooltip.prototype, "pvdId", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-open' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-open'))),
        __metadata("design:type", Boolean)
    ], PvdTooltip.prototype, "pvdOpen", void 0);
    __decorate([
        n({
            type: String,
            reflect: true,
            attribute: 'pvd-placement',
        }),
        __metadata("design:type", String)
    ], PvdTooltip.prototype, "pvdPlacement", void 0);
    __decorate([
        n({
            attribute: 'pvd-target',
        }),
        __metadata("design:type", Object)
    ], PvdTooltip.prototype, "pvdTarget", void 0);
    __decorate([
        n({
            type: String,
            reflect: false,
            attribute: 'pvd-text',
        }),
        __metadata("design:type", String)
    ], PvdTooltip.prototype, "pvdText", void 0);
    __decorate([
        n({
            type: String,
            reflect: false,
            attribute: 'pvd-trigger-button-a11y-text',
        }),
        __metadata("design:type", String)
    ], PvdTooltip.prototype, "pvdTriggerButtonA11yText", void 0);
    __decorate([
        n({
            type: String,
            reflect: true,
            attribute: 'pvd-z-index',
        }),
        __metadata("design:type", String)
    ], PvdTooltip.prototype, "pvdZIndex", void 0);
    return PvdTooltip;
}(PvdSlotifyBaseComponent));
var templateObject_1, templateObject_2, templateObject_3;

export { PvdTooltip };
